import mod from "-!./ExclamTrian.js?vue&type=script&lang=js&"; export default mod; export * from "-!./ExclamTrian.js?vue&type=script&lang=js&"